import { Injectable } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class KycService  extends AppService<any> {

  constructor(public http:HttpClient) {
    super(http);
    this.appmod="kyc";
  }

  submitKyc(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'addkyc';
    let result = this.saveService(data);
    this.appmod = tmp;
    return result;
  }

  updateKYC(data: any): Observable<any> {
    console.log(data)
    let tmp = this.appmod;
    this.appmod = 'updateKYC';
    let result = this.saveService(data);
    this.appmod = tmp;
    return result;
  }

  getFormPatchValue(id:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'getFormPatchValue';
    let result = this.saveService(id);
    this.appmod = tmp;
    return result;
  }

  getKYCdata(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'getallData';
    let result = this.getService();
    this.appmod = tmp;
    return result;
  }

  getUserKYCStatus(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'getUserKYCStatus';
    let result = this.getService();
    this.appmod = tmp;
    return result;
  }


}
